import { Navigate } from 'react-router-dom'
import { getVisibleNavigationSections } from '@/config/appNavigation'
import { Path } from '@/routes/paths'
import Loading from '@features/shared/components/Loading'
import { useAppNavigation } from '@features/navigation/hooks/useAppNavigation'

/**
 * Sends the user to the first page in the navigation rail. Used on the home
 * route when the AI module, which normally owns it, is switched off.
 */
export default function FirstAvailablePageRedirect() {
  const { modules, modulesPending, settingsNavigationPending } = useAppNavigation()
  // Until the user's modules and Settings pages arrive, the rail is missing
  // pages, and redirecting now would skip Tables for the Profile page.
  if (modulesPending || settingsNavigationPending) return <Loading />

  const firstPath = modules
    .flatMap((module) => getVisibleNavigationSections(module))
    .flatMap((section) => section.items)[0]?.to

  return <Navigate to={firstPath ?? Path.profile} replace />
}
